import { render, staticRenderFns } from "./OnBoardingHeader.vue?vue&type=template&id=0f4eb064&scoped=true&"
import script from "./OnBoardingHeader.vue?vue&type=script&lang=ts&"
export * from "./OnBoardingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OnBoardingHeader.vue?vue&type=style&index=0&id=0f4eb064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4eb064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
